<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Leaves",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Leaves",
            items: [
               {
                  text: "Doctors",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',
            schedule_from_date:'',
            schedule_date:'',
            from_date:'',
            to_date:'',
            upcoming: [],
            pin_no: "",
            curr_leave_id:'',
            hasSearchedUpcoming: false,
            hasSearchedHistory: false, 
            history: [],
            errors: {},
            today: current_date,
            leave_status: {
               id: "",
            },
         };
      },
      created() {
         //this.fetchUpcoming();
        // this.fetchHistory();
      },

      mounted() {
    
      },

      methods:{
         fetchUpcoming(page_url = null) {

            this.getToken();
            this.errors = {};
            let url = "api/admin/leave/upcomingLeaves?doctor_id=" +  this.$route.params.id + "&from_date=" + this.schedule_from_date + "&to_date=" + this.schedule_date;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.upcoming = responseData.leaves;
                  this.hasSearchedUpcoming = true;
                  this.setTime(1);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 
         fetchHistory(page_url = null) {

            this.getToken();
            this.errors = {};
            let url = "api/admin/leave/leaveHistory?doctor_id=" +  this.$route.params.id + "&from_date=" + this.from_date + "&to_date=" + this.to_date;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.history = responseData.leaves;
                   this.hasSearchedHistory = true;
                  this.setTime(2);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                            this.errors = error.response.data.message;
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
            }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         setTime(type) {
            var sessions;
            var schedules = [];
            if(type==1){
               sessions = this.upcoming;
            }else{
               sessions = this.history;
            }
            sessions.forEach(obj => {

               var session = {};
               session.start = obj.start_time;
               session.end = obj.end_time;
               session.session_id = obj.id;
               session.day = obj.day_id;
               session.duration = obj.duration;
               session.token_type = obj.token_type;
               session.clinic_name = obj.clinic_name;
               session.fee = obj.consultation_fee;

               var schedule = {};
               schedule.day = obj.day_id;               
               schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('hh:mm A');
               schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('hh:mm A');
               schedule.duration = obj.duration;
               schedule.token_type = obj.token_type;
               schedule.clinic_id = obj.clinic_id;
               schedule.clinic_name = obj.clinic_name;
               schedule.consultation_fee = obj.consultation_fee;
               schedule.date = obj.date;
               schedule.consultation_type= obj.consultation_type;
               schedule.doctor_edit_id= obj.doctor_edit_id;

               var set_time = obj.duration;
               var hour = set_time.split(':')[0];
               var minutes = set_time.split(':')[1];
               if(hour!='00'){
                  schedule.time_name = hour+' Hr '+ minutes +' min ';
               }else{
                  schedule.time_name =  minutes +' min ';
               }
               // schedule.clinic_name = obj.clinic_name;
               schedules.push(schedule); 

            });
            if(type==1){
               this.upcoming = schedules;
            }else{
               this.history = schedules;
            }
         }, 
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         handleFormSubmit(id) {
            this.showModal("pin-modal");
            this.curr_leave_id = id;
         },
         clearForm() {
            this.errors = {};
            this.pin_no = ''; 
            this.curr_leave_id = ''; 
         },
         
         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no); 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     // this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     this.unmarkLeave(this.curr_leave_id);
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         
         unmarkLeave(id) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want unmark leave?', {
                  title: 'Mark Leave?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                     this.leave_status.id = id;
                     this.updateLeaveStatus();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateLeaveStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/leave/unmarkLeave?doctor_edit_id=" + this.leave_status.id ;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchUpcoming();
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         }, 

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="row">
                     <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
            <template v-slot:title>
         
             <span class="">Upcoming Leaves</span>
            </template>
            <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="add"> -->
            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row">
                     <div class="form-group col-md-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_from_date"  :min="today"  v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"/>
                         <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>  
                     <div class="form-group col-md-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_date" :min="today"  v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }" />
                         <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div> 
                     <div class="col-md-4 d-flex align-items-center">
                        <span class="ms-2">
                           <b-button  variant="primary" @click="fetchUpcoming()" class="btn-sm" >View</b-button>
                        </span>
                     </div>
                      
                  </div>
                 
               </div>
            </div>
             <div v-if="hasSearchedUpcoming">
            <div v-if="upcoming.length > 0">
            <div v-for="(upcomin, index) in upcoming" :key="index">
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                             
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">{{upcomin.date|formatDate2}}</p></h4>
                                 <span class="mb-0">Time: {{ upcomin.start| formatTime }} - {{ upcomin.end| formatTime }} | {{upcomin.time_name}}<span v-if="upcomin.consultation_type==3"> | {{upcomin.clinic_name }}</span>
                                    <!-- <b-button  variant="danger" class="btn-sm float-end ms-2" @click="unmarkLeave(upcomin.doctor_edit_id)">Unmark Leave</b-button> -->
                                    <b-button  variant="danger" class="btn-sm float-end ms-2" @click="handleFormSubmit(upcomin.doctor_edit_id)">Unmark Leave</b-button>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==1">Video Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==2">Home Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="upcomin.consultation_type==3">Clinic Visit</span>
                                 </span>
                                 
                              </div>                              
                           </div>
               </b-card> 
            </div>
            </div>
            <div v-else class="text-center mt-3">
               <p>No upcoming leaves found.</p>
            </div>
            </div>
            </b-tab>

            <b-tab>
         
               <template v-slot:title>
         
         <span class="">Leave History</span>
        </template>
        <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="add"> -->
            <div class="card">
                  <div class="card-body">
                     <!----- filters area starts---->
                     <div class="row">
                        <div class="form-group col-md-4">
                           <label>From Date <span class="text-danger">*</span></label>
                           <input type="date" class="form-control" v-model="from_date" :max="today" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"/>
                           <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                        </div>  
                        <div class="form-group col-md-4">
                           <label>To Date <span class="text-danger">*</span></label>
                           <input type="date" class="form-control" v-model="to_date" :max="today" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"/>
                           <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                        </div> 
                        <div class="col-md-4 d-flex align-items-center">
                           <span class="ms-2">
                              <b-button  variant="primary" class="btn-sm" @click="fetchHistory()">View</b-button>
                           </span>
                        </div>
                        
                     </div>
                  
                  </div>
            </div>
             <div v-if="hasSearchedHistory">
            <div v-if="history.length > 0">
            <div v-for="(histo, index) in history" :key="index">
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">{{histo.date |formatDate2}}</p></h4>
                                 <span class="mb-0">Time: {{ histo.start| formatTime }} - {{ histo.end| formatTime }} | {{histo.time_name}}<span v-if="histo.consultation_type==3"> | {{histo.clinic_name }}</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==1">Video Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==2">Home Visit</span>
                                    <span class="btn btn-outline-primary btn-sm float-end" v-if="histo.consultation_type==3">Clinic Visit</span>                                 </span>
                                 
                              </div>                              
                           </div>
               </b-card>
            </div> 
            </div>
        <div v-else class="text-center mt-3">
               <p>No Leave History Found</p>
            </div>
            </div>
                        
          
            </b-tab>
            
            </b-tabs>
               

                     </div>
         </div>
      </div>

         <!---- modal starts ---->
         <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="checkPin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                  <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
